import { useState, useEffect } from 'react';
import './CookieConsent.css';

declare global {
  interface Window {
    SoomerSight?: {
      consent: {
        grant: () => void;
        deny: () => void;
      };
    };
  }
}

const CONSENT_KEY = 'cookie-consent-status';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);
  const [dismissing, setDismissing] = useState(false);

  useEffect(() => {
    const status = localStorage.getItem(CONSENT_KEY);
    if (!status) {
      setVisible(true);
    }
  }, []);

  const dismiss = (callback: () => void) => {
    setDismissing(true);
    callback();
    // Wait for animation to complete before hiding
    setTimeout(() => {
      setVisible(false);
    }, 300);
  };

  const handleAccept = () => {
    dismiss(() => {
      localStorage.setItem(CONSENT_KEY, 'granted');
      window.SoomerSight?.consent?.grant();
    });
  };

  const handleReject = () => {
    dismiss(() => {
      localStorage.setItem(CONSENT_KEY, 'denied');
      window.SoomerSight?.consent?.deny();
    });
  };

  if (!visible) return null;

  return (
    <div className={`cookie-consent-banner ${dismissing ? 'dismissing' : ''}`}>
      <div className="cookie-consent-content">
        <div className="cookie-consent-text">
          <p>We use cookies to analyze site traffic and improve your experience.</p>
        </div>
        <div className="cookie-consent-actions">
          <button
            className="btn btn-outline cookie-consent-reject"
            onClick={handleReject}
          >
            Reject
          </button>
          <button
            className="btn btn-primary cookie-consent-accept"
            onClick={handleAccept}
          >
            Accept
          </button>
        </div>
        <a href="/privacy-policy" className="cookie-consent-privacy-link">Privacy Policy</a>
      </div>
    </div>
  );
}
